import { UnknownCellArrayItem } from '@b-stock/fe-core/bstock-next/components'
import { Colors, pxToRem } from '@b-stock/fe-core/design-system'

import { Body as UnknownCellBody } from './unknownCell'

export enum CellClass {
  Dark = 'dark', // black

  SemiBold = 'semi-bold', // 600
  Bold = 'bold', // 700
  ExtraBold = 'extra-bold', // 800

  Small = 'small',

  Pill = 'pill', // grey pill
  Enum = 'enum', // colored pill -- enum-backed default
}

const pillBase = `
  border-radius: 0.25rem;
  display: inline-block;
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(22)};
  padding: 0 ${pxToRem(7)};
`

export const cellStyles = `
  .ag-cell-value {
    align-items: center;
    display: flex;


    &.${CellClass.Dark} {
      color: ${Colors.Semantic.Neutral.black};
    }

    &.${CellClass.SemiBold} {
      font-weight: 600;
    }

    &.${CellClass.Bold} {
      font-weight: 700;
    }

    &.${CellClass.ExtraBold} {
      font-weight: 800;
    }

    &.${CellClass.Small} {
      font-size: ${pxToRem(12)};
    }

    &.${CellClass.Pill} ${UnknownCellBody} {
      ${pillBase}
      background: ${Colors.Semantic.Neutral.light_grey};
      border: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
      color: ${Colors.Semantic.Neutral.black};
      font-weight: 600;

      .ag-row-hover & {
        background: ${Colors.Semantic.Neutral.dark_grey};
        border-color: ${Colors.Semantic.Neutral.dark_grey};
        color: white;
      }
    }

    &.${CellClass.Enum} {
      ${UnknownCellBody}[data-type="string"],
      ${UnknownCellArrayItem} {
        ${pillBase}
        background: ${Colors.Semantic.BStock.background.lightBackground};
        font-weight: 500;

        .ag-row-even & {
          background: ${Colors.Semantic.Neutral.light_grey};
        }

        .ag-row-hover & {
          background: ${Colors.Semantic.BStock.default.lightBackground};
          color: white;
        }
      }
    }
  }
`
